import { Component } from '@angular/core';
import { ClarifyChallengeComponent } from '../clarify-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-clarify-data',
  templateUrl: './clarify-data.component.html',
  styleUrls: ['./clarify-data.component.scss']
})
export class ClarifyDataComponent {

  constructor(public clarifyChallengeComponent: ClarifyChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const context = this.clarifyChallengeComponent?.datadump_content || [];
    this.aiService.openSidebar(
      'clarify', 'data', context,
      'Generate 5 data points or facts {persona} relevant to the challenge. Current context: {context}',
      'dupli_datadump_content', this.clarifyChallengeComponent
    );
  }
}
